import type { FC, ReactElement } from 'react'
import React from 'react'

import { FunctionalTab } from '@vfuk/core-functional-tabs'

import Icon from '@vfuk/core-icon'
import { getDataSelector } from '@vfuk/core-base-props'

import * as Styled from './styles/TabTitle.style'

import type { TabTitleProps } from './TabTitle.types'

const TabTitle: FC<TabTitleProps> = ({
  isActiveTab,
  tabId,
  tabWidth,
  text,
  appearance,
  inverse,
  isOverflowMenuOpen,
  onClick,
  onFocus,
  onKeyPress,
  overflowActive,
  dataSelectorPrefix,
  localTheme,
}): ReactElement => {
  return (
    <Styled.TabContainer
      role='presentation'
      overflowActive={overflowActive}
      tabWidth={tabWidth}
      onClick={onClick}
      onFocus={onFocus}
      onKeyPress={onKeyPress}
      data-selector={getDataSelector(dataSelectorPrefix)}
    >
      <FunctionalTab tabId={tabId} dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'functional-tab')}>
        <Styled.TabTitle
          isActiveTab={isActiveTab}
          appearance={appearance!}
          inverse={inverse!}
          tabWidth={tabWidth}
          data-text={text}
          tabsTheme={localTheme!}
          overflowActive={overflowActive}
          data-selector={getDataSelector(dataSelectorPrefix, 'tab-title')}
        >
          {text}
          {overflowActive && (
            <Styled.IconContainer isOverflowMenuOpen={isOverflowMenuOpen}>
              <Icon
                inverse={inverse!}
                name='chevron-down'
                size={1}
                dataSelectorPrefix={getDataSelector(dataSelectorPrefix, 'chevron-icon')}
              />
            </Styled.IconContainer>
          )}
        </Styled.TabTitle>
      </FunctionalTab>
    </Styled.TabContainer>
  )
}

export default TabTitle
